'use strict';
/* globals React, ReactDOM, classNames, _, $ */

var Suggestions = React.createClass({

  propTypes: {
    highlightedItem: React.PropTypes.number,
    searchTerm: React.PropTypes.string.isRequired,
    suggestions: React.PropTypes.array.isRequired,
    onSelection: React.PropTypes.func
  },

  getInitialState: function() {
    return {
      activeItem: -1
    };
  },

  componentDidMount: function() {
    $(ReactDOM.findDOMNode(this.refs.list)).css('minWidth', $('#quick-access').length > 0 ? $('#quick-access').outerWidth() : 100);
  },

  componentDidUpdate: function(prevProps) {
    if (this.props.highlightedItem > -1 && this.props.highlightedItem !== prevProps.highlightedItem) {
      this.scrollToActive();
    }
  },

  scrollToActive: function() {
    var $list = $(ReactDOM.findDOMNode(this.refs.list));
    var $element = $list.find('li[data-index="'+this.props.highlightedItem+'"]');
    if ($element.length > 0) {
      var rect = $element.get(0).getBoundingClientRect();
      var listRect = $list.get(0).getBoundingClientRect();
      var visible = rect.top >= listRect.top && rect.bottom <= listRect.bottom;
      if (!visible) {
        if (rect.bottom > listRect.bottom) {
          $list.scrollTop($list.scrollTop() + $element.position().top + $element.outerHeight() - $list.innerHeight());
        } else {
          $list.scrollTop($list.scrollTop() + $element.position().top);
        }

      }
    }
  },

  onTouchStart: function (index) {
    this.timer = setTimeout(() => {
      this.setState({ activeItem: index });
    }, 200);
  },

  onTouchMove: function() {
    clearTimeout(this.timer);
    this.touchedMoved = true;
    this.setState({ activeItem: -1 });
  },

  onTouchEnd: function (suggestion) {
    if (!this.touchedMoved) {
      setTimeout(function() {
        this.props.onSelection(suggestion);
      }, 220);
    }
    this.touchedMoved = false;
  },

  render: function() {
    var {highlightedItem, suggestions} = this.props;
    var {activeItem} = this.state;

    return (
      <ul
        className="search-bar-suggestions"
        onMouseLeave={() => this.setState({ activeItem: -1 })}
        ref="list">
        {suggestions.map((suggestion, index) =>
          (<li
            className={classNames({
              highlighted: highlightedItem === index || activeItem === index
            })}
            data-index={index}
            key={index}
            onClick={() => {this.props.onSelection(suggestion)}}
            onMouseEnter={() => this.setState({activeItem: index})}
            onMouseDown={(e) => e.preventDefault()}
            onTouchStart={() => this.onTouchStart(index)}
            onTouchMove={() => this.onTouchMove()}
            onTouchEnd={() => this.onTouchEnd(suggestion)}>
            <span>
              {/*searchTerm*/}
              {/*<strong>{suggestion.text.substr(searchTerm.length)}</strong>*/}
              {suggestion.text}
            </span>
          </li>)
        )}
      </ul>
    );
  }

});
window.Suggestions = Suggestions;

var keyCodes = {
  ENTER: 13,
  ESCAPE: 27,
  UP: 38,
  DOWN: 40
};

var SearchBar = React.createClass({

  propTypes: {
    autoFocus: React.PropTypes.bool,
    delay: React.PropTypes.number,
    inputName: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    onSearch: React.PropTypes.func,
    placeholder: React.PropTypes.string,
    icon: React.PropTypes.string,
    disabled: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      autoFocus: true,
      delay: 200,
      icon: 'search',
      disabled: false
    };
  },

  getInitialState: function() {
    return {
      highlightedItem: -1,
      searchTerm: '',
      suggestions: [],
      value: ''
    };
  },

  componentDidMount: function() {
    if (this.props.autoFocus) {
      this.refs.input.focus();
    }
  },

  normalizeInput: function() {
    return this.state.value.toLowerCase().trim();
  },

  autosuggest: function() {
    var searchTerm = this.normalizeInput();
    if (!searchTerm) return;
    new Promise((resolve) => {
      this.props.onChange(searchTerm, resolve);
    }).then((suggestions) => {
      if (!this.state.value) return;
      var highlighted = suggestions.length > 0 ? 0 : -1;
      this.setState({
        highlightedItem: highlighted,
        searchTerm: searchTerm,
        suggestions: suggestions
      });
    });
  },

  scroll: function (key) {
    var {highlightedItem: item, suggestions} = this.state;
    if (suggestions.length === 0) { return; }
    var lastItem = suggestions.length - 1;
    var nextItem;

    if (key === keyCodes.UP) {
      nextItem = (item <= 0) ? lastItem : item - 1;
    } else {
      nextItem = (item === lastItem) ? 0 : item + 1;
    }

    this.setState({
      highlightedItem: nextItem,
      value: suggestions[nextItem].text
    });
  },

  doSearch: function() {
    //var value = this.normalizeInput();
    var suggestion = this.state.highlightedItem > -1 ? this.state.suggestions[this.state.highlightedItem] : { id: null, text: this.normalizeInput() };
    clearTimeout(this.timer);
    this.refs.input.blur();
    this.setState(this.getInitialState());
    if (this.props.onSearch) {
      this.props.onSearch(suggestion);
    }
  },

  search: function() {
    if (!this.state.value) return;
    if (this.state.highlightedItem > -1) {
      this.setState({ value: this.state.suggestions[this.state.highlightedItem].text }, this.doSearch);
    } else {
      this.doSearch();
    }
  },

  onChange: function (e) {
    clearTimeout(this.timer);
    var input = e.target.value;
    if (!input) return this.setState(this.getInitialState());
    this.setState({ value: input });
    this.timer = setTimeout(() => this.autosuggest(), this.props.delay);
  },

  onKeyDown: function (e) {
    var key = e.which || e.keyCode;
    switch (key) {
    case keyCodes.UP:
    case keyCodes.DOWN:
      e.preventDefault();
      this.scroll(key);
      break;

    case keyCodes.ENTER:
      this.search();
      break;

    case keyCodes.ESCAPE:
      this.refs.input.blur();
      break;
    }
  },

  onSelection: function (suggestion) {
    let index = _.findIndex(this.state.suggestions, suggestion)
    this.setState({ value: suggestion.text, highlightedItem: index > -1 ? index : this.state.highlightedItem }, () => this.search());
  },

  onSearch: function (e) {
    e.preventDefault();
    this.search();
  },

  onBlur: function() {
    //this.setState({ isFocused: false, suggestions: [] });
    this.setState({ isFocused: false });
  },

  onFocus: function(e) {
    e.persist();
    this.setState({ isFocused: true }, function() {
      this.onChange({ target: e.target });
    }.bind(this));
  },

  render: function() {
    return (
      <div className="search-bar-wrapper">
        <div className={classNames(
          'search-bar-field', 'input-group',
          {'is-focused': this.state.isFocused},
          {'has-suggestions': this.state.suggestions.length > 0}
        )}>
          <input
            className="search-bar-input form-control"
            id="quick-access"
            name={this.props.inputName}
            type="text"
            maxLength="100"
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect="off"
            ref="input"
            value={this.state.value}
            placeholder={this.props.placeholder}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onKeyDown={this.state.suggestions && this.onKeyDown}
            onFocus={this.onFocus}
            disabled={this.props.disabled} />
          <span className="input-group-btn">
            <button className="btn btn-secondary search-bar-submit" type="button" onClick={this.onSearch}><Icon icon={this.props.icon} /></button>
          </span>
        </div>
        { this.state.suggestions.length > 0 && this.state.isFocused &&
          <Suggestions
            searchTerm={this.state.searchTerm}
            suggestions={this.state.suggestions}
            highlightedItem={this.state.highlightedItem}
            onSelection={this.onSelection} /> }
      </div>
    );
  }

});
window.SearchBar = SearchBar;
